export default __webpack_public_path__ + "static/image_evenement_s-1aa3e391dfd7c7d5020012c2365dc0cc.jpg";